// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__20lbC","itemA":"Write_itemA__3TgET","itemB":"Write_itemB__1o8vx","itemC":"Write_itemC__27EGQ"};